import type { SnapshotDataSourceID } from "../data-source";

import type { GEMDSnapshot } from "./gemd-snapshot";

export function snapshotToDataSourceId(
  snapshot: GEMDSnapshot,
): SnapshotDataSourceID {
  return `snapshot::${snapshot.id}`;
}

export function snapshotToDataSource(snapshot: GEMDSnapshot) {
  return {
    type: "snapshot_data_source",
    snapshot_id: snapshot.id,
  } as const;
}
